import { Flex, Icon, Input, Text, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { MAX_COMPANY_NAME_LENGTH } from '@features/invoicingSettings/constants/maxCompanyNameLength'
import { useUserOrganization, useUserOrganizationSettings } from '@modules-deprecated/app/organization'

import { ModalId } from '../../../../../../../../../../../../enums/modalId'
import { useIsInvoiceEditorElementRestricted } from '../../../../../../../../hooks/useIsInvoiceEditorElementRestricted'

export const InvoiceIssuerField = (): ReactElement => {
  const { t } = useTranslation()
  const isDisabled = useIsInvoiceEditorElementRestricted('issuer', 'disabled')
  const { organization } = useUserOrganization()
  const { organizationSettings } = useUserOrganizationSettings()
  const { open } = useModal(ModalId.CompanyInformationModal)

  const isCompanyInformationAdded = organizationSettings?.isCompanyInformationAdded === '1'

  const handleInputClick = useCallback(() => {
    if (isDisabled) {
      return
    }

    open()
  }, [isDisabled, open])

  return (
    <Flex flexDirection="column" justifyContent="space-between" flexGrow={1}>
      <Text colorVariant="secondary">{t('external_invoices.editor.form.field.issuer.label')}</Text>
      <Input
        disabled={isDisabled}
        maxLength={MAX_COMPANY_NAME_LENGTH}
        onClick={handleInputClick}
        placeholder={t('external_invoices.editor.form.field.issuer.placeholder')}
        prefix={<Icon icon="briefcaseBusiness" />}
        readOnly
        suffix={<Icon icon="squarePen" />}
        value={isCompanyInformationAdded ? organization?.name : ''}
        size="sm"
      />
    </Flex>
  )
}
